import { render, staticRenderFns } from "./QScoreCardHqActiveStaff.vue?vue&type=template&id=6ed574d2&scoped=true&"
import script from "./QScoreCardHqActiveStaff.vue?vue&type=script&lang=js&"
export * from "./QScoreCardHqActiveStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed574d2",
  null
  
)

export default component.exports